import React from 'react';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import { SubNav } from '../layout/submenu';
import { CustomAccordionToggle } from './CustomAccordionToggle';
import { DISPLAY_DATETIME_FORMAT2 } from '../../constants';

export const CrewCard = ({ item, today, timezone, selected,
    isAllowDelete, isAllowEdit, onSelect, onDelete, onPin, eventKey, expand }) => {
    const crewId = item.crew_uuid;
    const isPin = item.active;
    const isEndCrew = item.is_end_crew;
    const endCrewDate = moment.utc(item.end_crew_date).tz(timezone);
    const displayEndDate = item.alive ? (isEndCrew ? endCrewDate : null) : item.end_date;
    const isActive = (!item.alive || isEndCrew) ? false : true;
    const isSelected = (crewId === selected);

    return (<SubNav.Item selected={isSelected} className="highlight" >
        <SubNav.Card
            className={`${item.alive ? (isEndCrew ? "alive-danger" : "") : "alive-default"}`}
            onClick={onSelect.bind(this, item)}>
            <Row className={`p-0 m-0`}>
                <Col className="p-0" md={9} lg={9} sm={9}>
                    <span className={`p-0 m-0 ${expand ? '' : 'hidden'}`}>
                        <CustomAccordionToggle eventKey={eventKey} />
                    </span>
                    <SubNav.Name
                        className="word-wrap"
                        bullet={true}
                        title={item.crew_name}>
                        {item.crew_name}
                    </SubNav.Name>
                </Col>
                <Col className="p-0" md={3} lg={3} sm={3}>
                    {today && item.alive &&
                        <SubNav.ButtonGroup>
                            {isAllowDelete &&
                                <SubNav.DeleteButton
                                    onClick={onDelete.bind(this, crewId, item.crew_name)} />}
                            {isAllowEdit && !isEndCrew &&
                                <SubNav.FlagButton
                                    onClick={onPin.bind(this, crewId)}
                                    className="active-flag"
                                    active={isPin} />}
                        </SubNav.ButtonGroup>}
                </Col>
            </Row>
            <Row className={`p-0 m-0`}>
                <div className="d-flex">
                    <SubNav.DateRange
                        start={item.start_date}
                        end={displayEndDate}
                        alive={isActive}
                    />
                    {(isEndCrew && !item.alive) &&
                        <span className="ban-symbol"
                            title={`Ended @ ${endCrewDate.format(DISPLAY_DATETIME_FORMAT2)}`}>
                            <i className="fa fa-ban" aria-hidden="true" />
                        </span>}
                </div>
            </Row>
        </SubNav.Card>
    </SubNav.Item>);
};